// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1UB2B","itemTitle":"ClientEmergencyInfo_itemTitle__3Swn1","itemText":"ClientEmergencyInfo_itemText__1n5-D"};